var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-fade-transition',[(_vm.showGlobalLoader)?_c('page-loader'):_vm._e()],1),_c('app-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }